import { FC } from 'react';
import { Typography } from 'antd';
import FlexCol from '../atoms/FlexCol';

/** Informational placeholder — composite field formulas are now configured in the table's formula sequence editor. */
export const CompositeFormulaEditor: FC = () => (
    <FlexCol stretch>
        <Typography.Text type="secondary">
            Composite field formulas are configured in the table&apos;s formula sequence editor.
            Use dotted typeId targets (e.g. &quot;sellPriceUI.basePrice&quot;) to write into sub-fields.
        </Typography.Text>
    </FlexCol>
);
